import React from 'react';

export interface ScoreBarProps {
  label: string;
  value: number;
  color?: string;
}

export const ScoreBar: React.FC<ScoreBarProps> = ({ label, value, color = '#18365E' }) => {
  const n = Number.isFinite(value) ? value : 0;
  const width = Math.max(0, Math.min(100, n));
  const display = Number.isInteger(n) ? String(n) : n.toFixed(2);
  return (
    <div>
      <div className="flex justify-between items-center mb-1.5">
        <span className="text-xs font-medium text-[#717182]">{label}</span>
        <span className="text-xs font-bold text-[#18365E]">{display} / 100</span>
      </div>
      <div className="w-full bg-[#F5F7FA] rounded-full h-2.5 border border-[#e5e7eb]">
        <div className="h-2.5 rounded-full transition-all duration-500" style={{ width: `${width}%`, backgroundColor: color }} />
      </div>
    </div>
  );
};

export default ScoreBar;
